// extracted by mini-css-extract-plugin
export default {"toDoList":"ToDoList_toDoList__zkMYF"};